import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * SEO alias redirector.
 * /vs-rightmove → /for-agents?c=UK&src=rightmove
 * /vs-99acres   → /for-agents?c=IN&src=99acres
 * /vs-realtor   → /for-agents?c=CA&src=realtor
 *
 * Tracks the source for attribution.
 */
export const makeVsRedirect = (country, src) => () => {
  useEffect(() => {
    axios.post(`${API_URL}/api/sales/track-lead`, {
      source: `vs-${src}`,
      country,
      cta: 'page-view',
    }).catch(() => {});
  }, []);
  return <Navigate to={`/for-agents?c=${country}&src=${src}`} replace />;
};

export const VsRightmove = makeVsRedirect('UK', 'rightmove');
export const Vs99Acres = makeVsRedirect('IN', '99acres');
export const VsRealtor = makeVsRedirect('CA', 'realtor');
